import React, { useMemo, useCallback, useRef } from "react";
import styles from "./textcard.module.less";
import Avatar from "@/components/Avatar";
import lodashGet from "lodash/get";
import { getSimpleTextRemark } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dvajs";
import { getMessageSendType } from "@/utils/chat/message";
import { MessageSendType } from "@/types/chat/enum";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { message as toast } from "antd";
import { FocusSDK } from "@/utils";

interface IProps {
  message: any;
  currentEmployee: any;
  selectedSession: any;
}
function TextCard(props: IProps) {
  const { message, currentEmployee, selectedSession } = props;

  const dataInfo = useMemo(() => {
    const data = lodashGet(message, "data.0", {});
    let d;
    if (data?.orgNumberCard) {
      d = data?.orgNumberCard;
    } else {
      d = data;
    }
    return d || {};
  }, [message]);

  const sendType = useMemo(() => {
    return getMessageSendType(message, currentEmployee, selectedSession);
  }, [message, currentEmployee, selectedSession]);
  return (
    <div
      className={`${styles["text-card-wrap"]} ${
        sendType === MessageSendType.OTHER ? styles["other"] : ""
      }`}
    >
      <Avatar src={message?.sender?.avatar} />
      <div
        className={styles["text-message"]}
        dangerouslySetInnerHTML={{ __html: dataInfo?.content }}
      />
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(TextCard);
